import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export var MenuItemType;
(function (MenuItemType) {
    MenuItemType[MenuItemType["Custom"] = 0] = "Custom";
    MenuItemType[MenuItemType["DB"] = 1] = "DB";
    MenuItemType[MenuItemType["OpenApplication"] = 2] = "OpenApplication";
    MenuItemType[MenuItemType["NewApplication"] = 3] = "NewApplication";
    MenuItemType[MenuItemType["Authorization"] = 4] = "Authorization";
    MenuItemType[MenuItemType["CreditLimitIncrease"] = 5] = "CreditLimitIncrease";
    MenuItemType[MenuItemType["ExternalPopupWindow"] = 6] = "ExternalPopupWindow";
})(MenuItemType || (MenuItemType = {}));
export var LandingPage;
(function (LandingPage) {
    LandingPage["Classic"] = "Classic";
    LandingPage["Vulcan"] = "Vulcan";
    LandingPage["VulcanPortal"] = "VulcanPortal";
    LandingPage["Phoenix"] = "Phoenix";
})(LandingPage || (LandingPage = {}));
class VulcanDataResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.roleName = null;
        this.landingPage = LandingPage.Phoenix;
    }
    pk() {
        return "GetData";
    }
}
VulcanDataResource.urlRoot = legacyApiResourceUrl("VulcanData");
export { VulcanDataResource };
//# sourceMappingURL=VulcanDataResource.js.map